import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ChatMessage, POLARIS_NAME, UserMessageResponse} from '../../copilot.model';
import {CommonModule} from '@angular/common';
import {ProgressBarComponent} from '../progress-bar/progress-bar.component';
import {ButtonComponent} from "../../../../shared/components/button/button.component";
import {MarkdownComponent} from '../../../../shared/components/markdown/markdown.component';
import {CopilotCreativesMessageComponent} from './copilot-creatives-message/copilot-creatives-message.component';
import {CopilotGraphsMessageComponent} from './copilot-graphs-message/copilot-graphs-message.component';
import {CopilotFollowupQuestionsMessageComponent} from './copilot-followup-questions-message/copilot-followup-questions-message.component';
import {CopilotInsightsMessageComponent} from './copilot-insights-message/copilot-insights-message.component';
import {CopilotWebInsightsMessageComponent} from './copilot-web-insights-message/copilot-web-insights-message.component';
import {CopilotCitationsMessageComponent} from './copilot-citations-message/copilot-citations-message.component';
import { TrimSurroundingQuotesPipe } from "../../../../pipes/trim-surrounding-quotes.pipe";
import { ResponseActionButtonsComponent } from '../response-action-buttons/response-action-buttons.component';
import {PolarisIconComponent} from '../polaris-icon/polaris-icon.component';

@Component({
  selector: 'app-copilot-message',
  imports: [
    CommonModule,
    ProgressBarComponent,
    ButtonComponent,
    MarkdownComponent,
    CopilotCreativesMessageComponent,
    CopilotGraphsMessageComponent,
    CopilotFollowupQuestionsMessageComponent,
    CopilotInsightsMessageComponent,
    CopilotWebInsightsMessageComponent,
    CopilotCitationsMessageComponent,
    TrimSurroundingQuotesPipe,
    ResponseActionButtonsComponent,
    PolarisIconComponent
  ],
  templateUrl: './copilot-message.component.html',
  styleUrl: './copilot-message.component.scss'
})
export class CopilotMessageComponent {

  @Input() message!: ChatMessage;
  @Input() sendMessage!: string | null;
  @Input() shouldDisplayRetryButton = false;
  @Output() retryRequested = new EventEmitter<{ chatId: string; interactionId?: string }>();
  @Output() responseSelected = new EventEmitter<{ messageId: string; response: UserMessageResponse }>();
  @Output() chatNotFound = new EventEmitter<void>();
  public shouldDisplayMessage = false;
  public shouldDisplayThink = false;
  public isCopySucceeded = false;
  public polarisName = POLARIS_NAME;

  constructor() {
    setTimeout(() => {
      this.shouldDisplayMessage = true;
      this.shouldDisplayThink = true;
    }, 500);
    setTimeout(() => {
      this.shouldDisplayThink = false;
    }, 1500);
  }

  public tryAgain() {
    this.emitRetryRequested();
  }

  public async onCopy(): Promise<void> {
    const success = await this.copyTextToClipboard();
    if (success) {
      this.isCopySucceeded = true;
      setTimeout(() => {
        this.isCopySucceeded = false;
      }, 1000);
    }
  }

  private async copyTextToClipboard(): Promise<boolean> {
    if (!this.message.content) {
      return false;
    }
    let text = this.message.content
      + `${this.message.insights ? '\nInsights:\n' + this.message.insights : ''}`
      + `${this.message.webInsights ? '\nWeb Insights:\n' + this.message.webInsights : ''}`;
    // Remove markdown formatting
    text = text
      .replace(/\*\*/g, '')  // Remove bold markers
      .replace(/\*/g, '')    // Remove italic markers
      .replace(/\_\_/g, '')  // Remove bold underscores
      .replace(/\_/g, '')    // Remove italic underscores
      .replace(/\~/g, '');   // Remove strikethrough

    await navigator.clipboard.writeText(text);
    return true;
  }

  public onShare(): void {
   // TODO: implement share action when will have a design
  }

  public onGoodResponse(): void {
    this.message.userResponse = UserMessageResponse.POSITIVE;
    this.responseSelected.emit({
      messageId: this.message.id,
      response: UserMessageResponse.POSITIVE
    });
  }

  public onBadResponse(): void {
    this.message.userResponse = UserMessageResponse.NEGATIVE;
    this.responseSelected.emit({
      messageId: this.message.id,
      response: UserMessageResponse.NEGATIVE
    });
  }

  public onRetry(): void {
    this.emitRetryRequested();
  }

  public replaceCreativesInMessage(message: string, creativesURLs: string[]): string {
    let newMessage = message;
    let currentLetter = 'A';
    creativesURLs.forEach(url => {
      const urlSplit = url.split('/');
      newMessage = newMessage.replace(urlSplit[urlSplit.length - 1], currentLetter);
      currentLetter = String.fromCharCode(currentLetter.charCodeAt(0) + 1);
    });
    return newMessage;
  }

  private emitRetryRequested(): void {
    if (!this.sendMessage) {
      return;
    }
    this.retryRequested.emit({
      chatId: this.sendMessage,
      interactionId: this.message.interactionId
    });
  }
}
